module.exports = __webpack_public_path__ + "media/images/tutorial_header_sp2-04-1d57ed0d15582d09963077727510b73b.png";